import { type Job, type JobStatus } from "@vidario/domain";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

export interface UpdateJobStatusInput {
  id: string;
  status: JobStatus;
}

/** Update a Stelle's status. Used by "Stelle schließen" in the Dashboard /
 * Longlist header (MVP_requirements.md §5.1). The move to Empfehlung is the
 * recommendation release, see `useReleaseRecommendation`. */
export function useUpdateJobStatus(): UseMutationResult<Job, Error, UpdateJobStatusInput> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input) => client.updateJobStatus(input),
    onSuccess: (job) => {
      qc.setQueryData(queryKeys.job(job.id), job);
      qc.invalidateQueries({ queryKey: ["jobs"] });
    },
  });
}
